<template>
  <v-dialog :value="value" width="70%" @input="$emit('input', $event)">
    <v-card class="pa-4 clinic-modal-card">
      <div style="display: flex; align-items: center; justify-content: space-between; width: 100%;" class="mb-8">
        <div class="font-weight-bold" style="display: flex; align-items: center; line-height: 1; font-size: 14pt;">
          Actualmente en clínica
        </div>
        <v-btn small color="error" class="mt-0" @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text class="px-0 clinic-modal-body">
        <v-row class="mx-2 my-4">
          <v-col cols="12">
            <v-autocomplete
              outlined
              dense
              v-model="clinicPatientsForm.VisitData"
              :items="clinicItems"
              label="Motivo"
            />
          </v-col>

          <v-col cols="12" v-if="!veterinaryMode">
            <v-autocomplete
              outlined
              dense
              v-model="clinicPatientsForm.AsignedTo"
              :items="users"
              label="Asignado a"
            />
          </v-col>

          <v-col cols="12">
            <div class="d-flex align-center">
              <h4 class="mb-0">Estado:</h4>
              <p style="margin-left: 0.6rem; margin-bottom: 0;">{{ clinicPatientsForm.Status }}</p>
            </div>
          </v-col>

          <v-col cols="12" class="mb-4">
            <div style="display: flex; flex-wrap: wrap; justify-content: space-between; gap: 12px;">
              <div>
                <input
                  type="radio"
                  id="awaiting"
                  value="Espera"
                  v-model="clinicPatientsForm.Status"
                />
                <label class="spacing" for="awaiting"><b>Espera</b></label>
              </div>
              <div>
                <input
                  type="radio"
                  id="Attending"
                  value="Atendido"
                  v-model="clinicPatientsForm.Status"
                />
                <label class="spacing" for="Attending"><b>Atendido</b></label>
              </div>
              <div>
                <input
                  type="radio"
                  id="Attended"
                  value="Recuperación"
                  v-model="clinicPatientsForm.Status"
                />
                <label class="spacing" for="Attended"><b>Recuperación</b></label>
              </div>
              <div>
                <input
                  type="radio"
                  id="recovering"
                  value="Hospitalizado"
                  v-model="clinicPatientsForm.Status"
                />
                <label class="spacing" for="recovering"><b>Hospitalizado</b></label>
              </div>
            </div>
          </v-col>

          <v-col cols="12" v-if="veterinaryMode">
            <v-autocomplete
              outlined
              dense
              v-model="clinicPatientsForm.AsignedTo"
              :items="users"
              label="Asignado a para todos"
              @change="$emit('apply-global-assigned-to', clinicPatientsForm.AsignedTo)"
            />
          </v-col>

          <v-col cols="12">
            <div class="d-flex align-center justify-space-between mb-2">
              <h4 class="mb-0">Pacientes seleccionados</h4>
              <v-chip small color="primary" dark>
                {{ selectedPatients.length }}
              </v-chip>
            </div>

            <v-alert v-if="!selectedPatients.length" type="info" dense text>
              Selecciona pacientes desde la grilla para agregarlos a la lista.
            </v-alert>

            <div
              v-else
              style="display: flex; flex-direction: column; gap: 12px;"
            >
              <v-card
                v-for="patient in selectedPatients"
                :key="patient.ID_Patient"
                outlined
                class="pa-3"
                width="100%"
              >
                  <div class="d-flex align-center justify-space-between mb-4">
                    <div>
                      <div class="font-weight-bold">
                        ID: {{ patient.ID_Patient }} - {{ formatPatientName(patient) }}
                      </div>
                    </div>

                    <v-btn icon color="error" @click="$emit('remove-patient', patient.ID_Patient)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </div>

                  <v-row v-if="veterinaryMode">
                    <v-col cols="12">
                      <v-autocomplete
                        outlined
                        dense
                        :items="users"
                        :value="patient.AsignedTo"
                        label="Asignado a"
                        @change="$emit('update-patient-field', { patientId: patient.ID_Patient, field: 'AsignedTo', value: $event })"
                      />
                    </v-col>
                  </v-row>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn
          class="btn-save"
          :disabled="!selectedPatients.length || loading"
          :loading="loading"
          @click="$emit('save')"
        >
          Guardar Visita
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "ClinicPatientsModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    clinicPatientsForm: {
      type: Object,
      default: () => ({}),
    },
    clinicItems: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      default: () => [],
    },
    selectedPatients: {
      type: Array,
      default: () => [],
    },
    veterinaryMode: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatPatientName(patient) {
      if (!patient) {
        return "Paciente";
      }

      if (patient.NamePatient) {
        return patient.NamePatient;
      }

      const names = [patient.FirstName, patient.LastName].filter(Boolean);

      return names.length ? names.join(" ") : "Paciente";
    },
  },
};
</script>

<style scoped>
.spacing {
  margin-left: 0.6rem;
}

.clinic-modal-card {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.clinic-modal-body {
  overflow-y: auto;
  flex: 1 1 auto;
  min-height: 0;
  padding-right: 8px;
}
</style>
